module.exports = __webpack_public_path__ + "media/images/plans/photo_location/photo_location-1-b8779fa293fad138ae7fe89937ee0727.png";